const LOGO_URL = "https://customer-assets-7cd3h4nn.emergentagent.net/job_konversation-tracker/artifacts/maurfb7z_Ska%E2%95%A0%C3%A8ne%20logotyp_lokal_staende_positiv_rgb.png";

/**
 * Reusable Socialdemokraterna Skåne logo.
 *
 * The source PNG is the full "stacked" party logo (rose mark above the words
 * "Socialdemokraterna / Skåne"). We never crop it — the whole logo is always
 * shown, so the mark and the party name stay together.
 *
 * variant:
 *  - "stacked": just the logo, sized by `size`.
 *  - "inline":  the logo next to a small "Snacket" wordmark (default).
 * size: sm | md | lg | xl
 */
export default function Logo({ variant = "inline", size = "md", className = "", withSubtitle = false, subtitle = "Snacket" }) {
  const heights = { sm: 40, md: 52, lg: 88, xl: 140 };
  const h = heights[size] || 52;

  if (variant === "stacked") {
    return (
      <div className={`inline-flex flex-col items-center ${className}`}>
        <img src={LOGO_URL} alt="Socialdemokraterna Skåne" style={{ height: h }} className="object-contain"/>
        {withSubtitle && (
          <div className="mt-3 text-xs uppercase tracking-widest font-semibold text-[#E1251B]">{subtitle}</div>
        )}
      </div>
    );
  }
  // inline (default) — show FULL logo (no cropping) next to a "Snacket" wordmark
  const wordSize = size === "lg" ? "text-xl" : size === "sm" ? "text-sm" : "text-base";
  return (
    <div className={`inline-flex items-center gap-3 ${className}`}>
      <img src={LOGO_URL} alt="Socialdemokraterna Skåne" style={{ height: h }} className="object-contain flex-shrink-0"/>
      <div className={`font-heading font-extrabold tracking-tight text-slate-900 leading-tight ${wordSize}`}>Snacket</div>
    </div>
  );
}

export { LOGO_URL };
